let watermark = {}

let setWatermark = (str,date) => {
    let id = '1.23452384164.123412416'
    if (document.getElementById(id) !== null) {
      console.log(document.getElementById(id))
        document.body.removeChild(document.getElementById(id))
    }
    //创建一个画布
    let can = document.createElement('canvas')
    //设置画布的长宽
    can.width = 200
    can.height = 150

    let cans = can.getContext('2d')
    //旋转角度
    cans.rotate(-15 * Math.PI / 180)
    cans.font = "normal 16px/10px Arial"
    cans.rotate(10* Math.PI / 90);
    
    //设置填充绘画的颜色、渐变或者模式
    cans.fillStyle = 'rgba(180, 180, 180, 0.15)'
    //设置文本内容的当前对齐方式
    cans.textAlign = 'left'
    //设置在绘制文本时使用的当前文本基线
    cans.textBaseline = 'Middle';
    //在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
    cans.fillText(str, can.width / 3, can.height / 2)
    setTimeout(()=>{
    let div = document.createElement('div')
    div.id = id
    div.style.pointerEvents = 'none'
    div.style.top = '30px'
    div.style.left = '0px'
    div.style.bottom = '0px'
    div.style.position = 'absolute'
    div.style.zIndex = '100000'
    div.style.width = document.documentElement.clientWidth + 'px'
    div.style.height = document.getElementById("show").scrollHeight; + 'px'
    div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
    //   document.body.appendChild(div)
    let show = document.getElementById("show") // 控制水印显示的区域，设置id = show,表示在该范围内有水印
    if(show){
      show.appendChild(div)
    return id
    }
    },1000)
    
    
}

// 该方法只允许调用一次
watermark.set = (str) => {
    let id = setWatermark(str) // str,date代表的是两行水印。如果需好几个的话再追加。
    setTimeout(() => {
        if (document.getElementById(id) === null) {
            id = setWatermark(str)

        }
    }, 500);
    window.onresize = () => {
        setWatermark(str)
    };
}

export default watermark